import React from "react";
import { Form } from "react-bootstrap";

const Feedback = ({ error }) => <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>;

export default Feedback;
